import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareName } from '../../fragments/generated/ShareName';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteShareMutationVariables = Types.Exact<{
  input: Types.DeleteShareInput;
}>;


export type DeleteShareMutation = { __typename?: 'Mutation', deleteShare?: { __typename?: 'DeleteSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, name: string } | { __typename?: 'CollectionShare', id: string, name: string } | null } | null };


export const DeleteShare = /*#__PURE__*/ gql`
    mutation DeleteShare($input: DeleteShareInput!) {
  deleteShare(input: $input) {
    share {
      ...ShareName
    }
  }
}
    ${ShareName}` as unknown as DocumentNode<DeleteShareMutation, DeleteShareMutationVariables>;

          

          export const useDeleteShareMutation = (options?:MutationHookOptions<DeleteShareMutation, DeleteShareMutationVariables>) => useMutation(DeleteShare, options);
          

          export type DeleteShareMutationOptions = MutationHookOptions<DeleteShareMutation, DeleteShareMutationVariables>;

          

          export type DeleteShareMutationResult = ReturnType<typeof useDeleteShareMutation>[1];

          
